import { Popover } from "@digdir/designsystemet-react";
import { InformationSquareIcon } from "@navikt/aksel-icons";
import type { PropsWithChildren } from "react";

type HelpTextProps = {
  hjelpeTekst: string;
  ariaLabel?: string;
};

export const HjelpeTekst = ({
  children,
  hjelpeTekst,
  ariaLabel,
}: PropsWithChildren<HelpTextProps>) => {
  return (
    <div className="flex items-center gap-2">
      {children}
      {true && (
        <Popover.TriggerContext>
          <Popover.Trigger
            inline
            aria-label={ariaLabel}
            className="inline-flex"
          >
            <InformationSquareIcon fontSize="1.5rem" />
          </Popover.Trigger>
          <Popover>
            <span className="font-normal">{hjelpeTekst}</span>
          </Popover>
        </Popover.TriggerContext>
      )}
    </div>
  );
};
